import { useMutation, useQuery } from "@apollo/client";
import { gql } from "types";

const MOHRE_USE_MOCK = gql(/* GraphQL */ `
  query DevToolbarMohreUseMock {
    mohreUseMock
  }
`);

const SET_MOHRE_USE_MOCK = gql(/* GraphQL */ `
  mutation DevToolbarSetMohreUseMock($value: Boolean!) {
    setMohreUseMock(value: $value)
  }
`);

export const useMohreMock = () => {
  const { data, loading } = useQuery(MOHRE_USE_MOCK);
  const [setMohreUseMock, { loading: updating }] = useMutation(
    SET_MOHRE_USE_MOCK,
    {
      refetchQueries: [{ query: MOHRE_USE_MOCK }],
      awaitRefetchQueries: true,
    },
  );

  const setMockEnabled = async (value: boolean) => {
    await setMohreUseMock({ variables: { value } });
  };

  return {
    mockEnabled: data?.mohreUseMock,
    loading,
    updating,
    setMockEnabled,
  };
};
